import "core-js/modules/es.array.reverse.js";
var _class, _descriptor;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import classNames from "classnames";
import { action, makeObservable, computed as mobxComputed, observable } from "mobx";
import { observer } from "mobx-react";
import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import filterOutUndefined from "../../Core/filterOutUndefined";
import MappableMixin, { ImageryParts } from "../../ModelMixins/MappableMixin";
import GeoJsonCatalogItem from "../../Models/Catalog/CatalogItems/GeoJsonCatalogItem";
import CommonStrata from "../../Models/Definition/CommonStrata";
import CreateModel from "../../Models/Definition/CreateModel";
import ViewerMode from "../../Models/ViewerMode";
import MappableTraits from "../../Traits/TraitsClasses/MappableTraits";
import TerriaViewer from "../../ViewModels/TerriaViewer";
import Styles from "./data-preview-map.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// AdaptForPreviewMap class remains largely the same
let AdaptForPreviewMap = (_class = class AdaptForPreviewMap extends MappableMixin(CreateModel(MappableTraits)) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "previewed", _descriptor, this);
    makeObservable(this);
  }
  async forceLoadMapItems() {}
  get mapItems() {
    var _this$previewed$mapIt, _this$previewed;
    return (_this$previewed$mapIt = (_this$previewed = this.previewed) === null || _this$previewed === void 0 ? void 0 : _this$previewed.mapItems.map(m => ImageryParts.is(m) ? _objectSpread(_objectSpread({}, m), {}, {
      alpha: m.alpha !== 0.0 ? 1.0 : 0.0,
      show: true
    }) : m)) !== null && _this$previewed$mapIt !== void 0 ? _this$previewed$mapIt : [];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "previewed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "mapItems", [mobxComputed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
const createBoundingRectangleCatalogItem = function (terria, bbox) {
  let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "__preview-data-extent";
  const rectangleCatalogItem = new GeoJsonCatalogItem(id, terria);
  rectangleCatalogItem.setTrait(CommonStrata.user, "geoJsonData", {
    type: "FeatureCollection",
    features: [{
      type: "Feature",
      properties: {
        stroke: "#08ABD5",
        "stroke-width": 2,
        "stroke-opacity": 1
      },
      geometry: {
        type: "LineString",
        coordinates: [[bbox.west, bbox.south], [bbox.west, bbox.north], [bbox.east, bbox.north], [bbox.east, bbox.south], [bbox.west, bbox.south]]
      }
    }]
  });
  rectangleCatalogItem.loadMapItems();
  return rectangleCatalogItem;
};
const DataPreviewMap = observer(props => {
  var _previewed$loadMapIte2, _previewed$loadMetada2;
  const {
    t
  } = useTranslation();
  const {
    terria,
    previewed,
    showMap
  } = props;
  const mapContainerRef = useRef(null);
  const isZoomedToExtentRef = useRef(false);
  const homeCamera = useMemo(() => {
    return terria.mainViewer.homeCamera;
  }, [terria]);
  const boundingRectangleCatalogItem = useMemo(() => {
    const rectangle = previewed === null || previewed === void 0 ? void 0 : previewed.rectangle;
    if (!rectangle) {
      return undefined;
    }
    const {
      west,
      south,
      east,
      north
    } = rectangle;
    if (west === undefined || south === undefined || east === undefined || north === undefined) {
      return undefined;
    }
    return createBoundingRectangleCatalogItem(terria, {
      west,
      south,
      east,
      north
    }, "__preview-data-extent");
  }, [previewed === null || previewed === void 0 ? void 0 : previewed.rectangle, terria]);
  const zoomedOutBoundingRectangleCatalogItem = useMemo(() => {
    const rectangle = previewed === null || previewed === void 0 ? void 0 : previewed.rectangle;
    if (!rectangle) {
      return undefined;
    }
    let {
      west,
      south,
      east,
      north
    } = rectangle;
    if (west === undefined || south === undefined || east === undefined || north === undefined) {
      return undefined;
    }

    // When zoomed out, make sure the dataset rectangle is at least 5% of the width and height
    // the home view, so that it is actually visible.
    const minimumFraction = 0.05;
    const homeView = homeCamera;
    const minimumWidth = CesiumMath.toDegrees(homeView.rectangle.width) * minimumFraction;
    if (east - west < minimumWidth) {
      const center = (east + west) * 0.5;
      west = center - minimumWidth * 0.5;
      east = center + minimumWidth * 0.5;
    }
    const minimumHeight = CesiumMath.toDegrees(homeView.rectangle.height) * minimumFraction;
    if (north - south < minimumHeight) {
      const center = (north + south) * 0.5;
      south = center - minimumHeight * 0.5;
      north = center + minimumHeight * 0.5;
    }
    return createBoundingRectangleCatalogItem(terria, {
      west,
      south,
      east,
      north
    }, "__preview-data-extent-zoomed-out");
  }, [homeCamera, previewed === null || previewed === void 0 ? void 0 : previewed.rectangle, terria]);
  const previewViewer = useMemo(() => {
    const viewer = new TerriaViewer(terria, mobxComputed(() => {
      const previewItem = new AdaptForPreviewMap(undefined, terria);
      previewItem.previewed = previewed;
      return filterOutUndefined([previewItem, boundingRectangleCatalogItem, zoomedOutBoundingRectangleCatalogItem]);
    }));
    viewer.viewerMode = ViewerMode.Leaflet;
    viewer.disableInteraction = true;
    viewer.homeCamera = homeCamera;
    return viewer;
  }, [boundingRectangleCatalogItem, homeCamera, previewed, terria, zoomedOutBoundingRectangleCatalogItem]);
  useEffect(() => {
    const container = mapContainerRef.current;
    const baseMapItems = terria.baseMapsModel.baseMapItems;
    const initPreviewBaseMap = action(() => baseMapItems.find(bm => bm.item.uniqueId === terria.baseMapsModel.previewBaseMapId))();
    if (initPreviewBaseMap) {
      previewViewer.setBaseMap(initPreviewBaseMap.item);
    } else {
      previewViewer.setBaseMap(baseMapItems.length > 0 ? baseMapItems[0].item : undefined);
    }
    previewViewer.attach(container);
    return () => {
      if (previewViewer.attached) {
        previewViewer.detach();
      }
    };
  }, [previewViewer, terria.baseMapsModel.baseMapItems, terria.baseMapsModel.previewBaseMapId]);
  const toggleZoom = action(() => {
    isZoomedToExtentRef.current = !isZoomedToExtentRef.current;
    if (isZoomedToExtentRef.current) {
      boundingRectangleCatalogItem === null || boundingRectangleCatalogItem === void 0 || boundingRectangleCatalogItem.setTrait(CommonStrata.override, "show", true);
      zoomedOutBoundingRectangleCatalogItem === null || zoomedOutBoundingRectangleCatalogItem === void 0 || zoomedOutBoundingRectangleCatalogItem.setTrait(CommonStrata.override, "show", false);
      if (previewed) {
        previewViewer === null || previewViewer === void 0 || previewViewer.currentViewer.zoomTo(previewed);
      }
    } else {
      boundingRectangleCatalogItem === null || boundingRectangleCatalogItem === void 0 || boundingRectangleCatalogItem.setTrait(CommonStrata.override, "show", false);
      zoomedOutBoundingRectangleCatalogItem === null || zoomedOutBoundingRectangleCatalogItem === void 0 || zoomedOutBoundingRectangleCatalogItem.setTrait(CommonStrata.override, "show", true);
      previewViewer.currentViewer.zoomTo(previewViewer === null || previewViewer === void 0 ? void 0 : previewViewer.homeCamera);
    }
  });
  const previewBadgeState = useMemo(() => {
    var _previewed$loadMetada, _previewed$loadMapIte;
    if (previewed !== null && previewed !== void 0 && previewed.isLoading) return "loading";
    if (previewed !== null && previewed !== void 0 && (_previewed$loadMetada = previewed.loadMetadataResult) !== null && _previewed$loadMetada !== void 0 && _previewed$loadMetada.error || previewed !== null && previewed !== void 0 && (_previewed$loadMapIte = previewed.loadMapItemsResult) !== null && _previewed$loadMapIte !== void 0 && _previewed$loadMapIte.error) return "dataPreviewError";
    if ((!(previewed !== null && previewed !== void 0 && previewed.mapItems) || previewed.mapItems.length === 0) && !boundingRectangleCatalogItem) return "noPreviewAvailable";
    return "dataPreview";
  }, [boundingRectangleCatalogItem, previewed === null || previewed === void 0 ? void 0 : previewed.isLoading, previewed === null || previewed === void 0 || (_previewed$loadMapIte2 = previewed.loadMapItemsResult) === null || _previewed$loadMapIte2 === void 0 ? void 0 : _previewed$loadMapIte2.error, previewed === null || previewed === void 0 || (_previewed$loadMetada2 = previewed.loadMetadataResult) === null || _previewed$loadMetada2 === void 0 ? void 0 : _previewed$loadMetada2.error, previewed === null || previewed === void 0 ? void 0 : previewed.mapItems]);
  const previewBadgeLabels = {
    loading: t("preview.loading"),
    noPreviewAvailable: t("preview.noPreviewAvailable"),
    dataPreview: t("preview.dataPreview"),
    dataPreviewError: t("preview.dataPreviewError")
  };
  return /*#__PURE__*/_jsxs("div", {
    className: Styles.map,
    onClick: toggleZoom,
    children: [showMap ? /*#__PURE__*/_jsx("div", {
      className: classNames(Styles.terriaPreview),
      ref: mapContainerRef
    }, "terria-preview-map") : /*#__PURE__*/_jsx("div", {
      className: classNames(Styles.terriaPreview, Styles.placeholder)
    }, "terria-preview-placeholder"), /*#__PURE__*/_jsx("label", {
      className: Styles.badge,
      children: previewBadgeLabels[previewBadgeState] || ""
    })]
  });
});
export default DataPreviewMap;